import COLORS from "shared/config/colors";

import HStack from "shared/components/layout/stack/HStack";
import PropTypes from "prop-types";
import React from "react";
import Text from "shared/components/data-display/text/Text";
import VStack from "shared/components/layout/stack/VStack";
import { StyledTextLabel, TimeOffCard, TotalWrapper, VStackWrapper, VerticalLine } from "./SummaryTimeOffCard.styles";

const SummaryTimeOffCard = ({
    isSmallSize = false,
    currentCards = null,
    title,
    remainingTime,
    totalTime,
}) => {
    const titleVariant = isSmallSize ? "Descriptive_2_2" : "Descriptive_1_2";
    const labelVariant = isSmallSize ? "Descriptive_2_1" : "Descriptive_1_1";
    const labelContentVariant = isSmallSize ? "Headline_4" : "Headline_3";

    return (
        <TimeOffCard isSmallSize={isSmallSize} currentCards={currentCards}>
            <VStack>
                <StyledTextLabel variant={titleVariant} color={COLORS.Gray_1}>
                    {title}
                </StyledTextLabel>
            </VStack>
            <HStack spacing="Zero">
                <VStackWrapper spacing={"Zero"}>
                    <StyledTextLabel
                        variant={labelVariant}
                        color={COLORS.Gray_2}
                    >
                        {"Remaining "}
                    </StyledTextLabel>
                    {remainingTime < 0 ? (
                        <StyledTextLabel
                            variant={labelContentVariant}
                            color={COLORS.Orange_1}
                        >
                            ({remainingTime * -1})
                        </StyledTextLabel>
                    ) : (
                        <StyledTextLabel
                            variant={labelContentVariant}
                            color={COLORS.Black}
                        >
                            {remainingTime}
                        </StyledTextLabel>
                    )}
                </VStackWrapper>
                <VerticalLine></VerticalLine>
                <TotalWrapper spacing="Zero">
                    <Text variant={labelVariant} color={COLORS.Gray_2}>
                        Total
                    </Text>
                    <Text variant={labelContentVariant} color={COLORS.Black}>
                        {totalTime}
                    </Text>
                </TotalWrapper>
            </HStack>
        </TimeOffCard>
    );
};

SummaryTimeOffCard.propTypes = {
    isSmallSize: PropTypes.bool,
    currentCards: PropTypes.any,
    title: PropTypes.string.isRequired,
    remainingTime: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    totalTime: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
};

export default SummaryTimeOffCard;
